import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  CHAT_GROUP_BY_COMPONENT,
  CHAT_GROUP_BY_ID,
  CHAT_GROUP_CREATE,
  CHAT_GROUP_DEACTIVATE,
  MESSAGES_GROUP,
  MESSAGES_GROUP_ALL,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const chatGroupCreate = createAsyncThunk(
  CHAT_GROUP_CREATE,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_GROUP}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.chatGroupCreate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatGroupDeactivate = createAsyncThunk(
  CHAT_GROUP_DEACTIVATE,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_GROUP_DEACTIVATE}{id}`, 'put'>, { rejectWithValue }) => {
    try {
      const response = await api.chatGroupDeactivate(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatGroupByComponent = createAsyncThunk(
  CHAT_GROUP_BY_COMPONENT,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_GROUP_BY_COMPONENT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.chatGroupByComponent(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatGroupByComponentClear = createAction(`${CHAT_GROUP_BY_COMPONENT}/clear`)

export const chatGroupById = createAsyncThunk(
  CHAT_GROUP_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_GROUP}{id}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.chatGroupById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatGroupByIdClear = createAction(`${CHAT_GROUP_BY_ID}/clear`)

export const messagesGroup = createAsyncThunk(
  MESSAGES_GROUP,
  async (params: PayloadCreatorParams<`${typeof API.MESSAGES_GROUP}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.messagesGroup(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const messagesGroupClear = createAction(`${MESSAGES_GROUP}/clear`)

export const messagesGroupAll = createAsyncThunk(
  MESSAGES_GROUP_ALL,
  async (params: PayloadCreatorParams<`${typeof API.MESSAGES_GROUP_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.messagesGroupAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const messagesGroupAllClear = createAction(`${MESSAGES_GROUP_ALL}/clear`)
